import styled from "styled-components";

export const Style = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  width: 100dvw;
  height: calc(100dvh - 64px);
  top: 64px;
  left: 0px;
  z-index: 1001;
  display: flex;
  flex-direction: row;
  animation: .4s fadeIn forwards;

  &.user-dropdown {
    justify-content: flex-end;
  }

  div {
    line-height: 0px;
  }

  .sidenav-sider {
    display: flex;
    flex-direction: column;
    
    .anticon {
      line-height: 0px !important;
    }

    span[role="img"] {
      padding: 0;
    }

    .close-icon {
      margin-top: 20px;
    }

    .mod-name {
      margin-bottom: 20px;
      margin-top: 20px;
    }
  }

  .drawer {
    width: 250px;
    transition: .4s margin-right;
    height: 100%;
    display: flex;
    flex-direction: column;

    .sidenav-cont {
      svg {
        margin-right: 0px;
      }
      
      span {
        padding-left: 0px;
      }

      height: unset;
      flex: 1;
      overflow-y: auto;
      max-height: calc(100dvh - 125px);

      .log-out {
        padding-top: var(--size-lg);
        margin: 0px var(--size-lg);
        cursor: pointer;

        span {
          padding-left: 10px;
          margin-left: 10px;
        }
      }
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }


  &.closed {
    display: none;
  }
`;
